export default /* glsl */`
uniform vec3 color0;
uniform vec3 color1;
uniform float ratio0;
uniform float ratio1;
uniform float rotate;
uniform bool fixChubb;
`;
